import { Link } from '@ta-interaktiv/contentbricks'
import parseHostname from '@ta-interaktiv/parse-hostname'
import { monthnameslong } from 'components/main/main.component'
import React, { useState } from 'react'
import styled from 'styled-components'

const isMobile = window.innerWidth < 712

const StyledOverlay = styled.div<{ checked: boolean; rowpos: number }>`
  z-index: 1000;
  background-color: #f00;
  position: ${isMobile ? 'fixed' : 'absolute'};
  left: ${({ rowpos }) =>
    isMobile ? '0px' : rowpos >= 2 ? 'calc(-200% + 10px)' : '15px'};
  top: ${isMobile ? '0px' : '15px'};
  right: ${isMobile ? '0px' : undefined};
  bottom: ${isMobile ? '0px' : undefined};
  width: ${isMobile ? undefined : 'calc(300% - 25px)'};
  background-color: ${({ checked }) =>
    checked ? 'var(--green-bright-3)' : 'var(--beige-bright-3)'};
  background-color: #fff;

  line-height: 22px;
  text-align: left;
  font-size: 15px;
  pointer-events: all;
  -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  overflow: ${isMobile ? undefined : 'hidden'};
  overflow-y: ${isMobile ? 'scroll' : undefined};
`

const Text = styled.div`
  width: 100%;
  padding: 20px;
  padding-bottom: ${isMobile ? '80px' : '30px'};
  padding-top: 0;
`
const Facts = styled.div<{ checked: boolean }>`
  width: 100%;
  padding: 20px;
  padding-bottom: 5px;
  padding-top: 25px;
  background-color: ${({ checked }) =>
    checked ? 'var(--green-bright-3)' : 'var(--beige-bright-2)'};
`
const FactElementWrapper = styled.div`
  width: 100%;
  margin-bottom: 15px;

  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`
const FactElement = styled.div<{ wide?: boolean }>`
  width: 100%;
  flex: ${({ wide }) => (wide ? '0 0 100%' : '0 0 50%')};
  line-height: 1.4em;
  padding-top: 10px;
`
const FactElementLabel = styled.label`
  display: inline-block;
  width: 100%;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
`
const FactElementValue = styled.div`
  display: inline-block;
  width: 100%;
  font-size: 15px;
`

const IlluContainer = styled.div`
  width: 100%;
  text-align: center;
  padding-bottom: 30px;
  img {
    width: 100%;
    max-width: 180px !important;
  }
`
const Name = styled.div`
  width: 100%;
  font-size: 26px;
  font-weight: 700;
  line-height: 32px;
  font-family: 'Suez One', var(--font-plex);
`
const AlternativeName = styled.div`
  width: 100%;
  font-size: 15px;
  font-weight: 400;
  padding-bottom: 10px;
`

const CloseButton = styled.div`
  display: inline-block;
  width: 50px;
  height: 50px;
  background-color: ${isMobile ? 'var(--brandblue-main)' : 'transparent'};
  position: ${isMobile ? 'fixed' : 'absolute'};
  bottom: ${isMobile ? '20px' : undefined};
  top: ${isMobile ? undefined : '10px'};
  right: ${isMobile ? '0px' : '10px'};
  img {
    width: 100%;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const Overlay = ({
  isChecked,
  data,
  labels,
  rowPosition,
  lang = 'de',
  handleClose
}: {
  isChecked: boolean
  data: FruitElementType
  labels: (string | string[])[]
  rowPosition: number
  lang: 'de' | 'fr'
  handleClose: (e: number | undefined) => void
}) => {
  const {
    bez,
    bez_alternativ,
    verw_alt_text,
    imageid,
    normfrom,
    normto,
    upto3,
    upto7,
    upto14,
    receipeid
  } = data
  const startmonth = new Date(
    1000 * 60 * 60 * 24 * 7 * +normfrom
  ).toLocaleDateString(lang + '-CH', {
    month: 'long'
  })

  const endmonth = new Date(
    1000 * 60 * 60 * 24 * 7 * +normto
  ).toLocaleDateString(lang + '-CH', {
    month: 'long'
  })

  const usage = [
    ['roh', labels[0][0]],
    ['braten', labels[0][1]],
    ['duensten', labels[0][2]],
    ['backen', labels[0][3]],
    ['kompott', labels[0][4]],
    ['waehe', labels[0][5]],
    ['kochen', labels[0][6]]
  ]
    .map(m => (data[m[0]] ? m[1] : undefined))
    .filter(f => f)
    .join(', ')
  return (
    <StyledOverlay checked={isChecked} rowpos={rowPosition}>
      <Facts checked={isChecked}>
        <IlluContainer>
          <img
            src={
              'https://interaktiv.tagesanzeiger.ch/2022/obst-und-gemuese-kalender/Illus/' +
              imageid +
              '-g.png'
            }
          />{' '}
          {/* <img src={getIllustration(imageid, 'g')} /> */}
        </IlluContainer>
        <Name>{bez}</Name>
        <AlternativeName>{bez_alternativ}</AlternativeName>
        <FactElementWrapper>
          <FactElement>
            <FactElementLabel>{labels[2][0]}</FactElementLabel>
            <FactElementValue>
              {startmonth} - {endmonth}
            </FactElementValue>
          </FactElement>
          <FactElement>
            <FactElementLabel>{labels[3][0]}</FactElementLabel>
            <FactElementValue>
              {upto3
                ? labels[3][1]
                : upto7
                ? labels[3][2]
                : upto14
                ? labels[3][3]
                : labels[3][4]}
            </FactElementValue>
          </FactElement>
          <FactElement wide>
            <FactElementLabel>{labels[2][1]}</FactElementLabel>
            <FactElementValue>{usage}</FactElementValue>
          </FactElement>
        </FactElementWrapper>
      </Facts>
      <Text>
        <FactElementWrapper>
          <FactElement wide>
            {receipeid && (
              <>
                <FactElementLabel>{labels[4][0]}</FactElementLabel>
                {receipeid
                  .toString()
                  .split(',')
                  .map((m: string) => {
                    let linkdata = m.split('|')

                    return <RecipeLink id={linkdata[1]} text={linkdata[0]} />
                  })}
              </>
            )}
          </FactElement>
        </FactElementWrapper>
        {verw_alt_text}
      </Text>
      <CloseButton onClick={() => handleClose(undefined)}>
        <img
          src={require('images/icons/icons_close' +
            (isMobile ? '_mob' : '') +
            '.png')}
        />
      </CloseButton>
    </StyledOverlay>
  )
}
const LinkWrapper = styled.div`
  line-height: 1.6em;
  float: left;
  margin-right: 1em;
`
const RecipeLink = ({ id, text }: { id: string; text: string }) => (
  <LinkWrapper>
    <Link href={id}>{text}</Link>
  </LinkWrapper>
)
